import { render, staticRenderFns } from "./UpImgOrVideo.vue?vue&type=template&id=be26e668&scoped=true&"
import script from "./UpImgOrVideo.vue?vue&type=script&lang=js&"
export * from "./UpImgOrVideo.vue?vue&type=script&lang=js&"
import style0 from "./UpImgOrVideo.vue?vue&type=style&index=0&id=be26e668&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be26e668",
  null
  
)

export default component.exports